import { useState } from "react";
import { createModel } from "hox";
import { enquiryService } from "../../dtpService";
import { IDtpTabEnum, IDtpMaterialDetail, IDtpDetail, IPdfType, IAuditPdf } from "../../dtpTypes";
import { IMaterialDetail } from "@/views/base/material/materialService";
import { message } from "antd";
import useGlobalModel from "@/model/globalModel";
import { useLockFn } from "ahooks";
import { convertRes2Blob } from "@/utils/exportFile";
import moment from "moment";
import { formatInt, formatNum, formatNum4, momentFormat } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";


export const useDtpDetailModel = createModel(function () {
    const { user: { shopCode, shopName }, setLoadingInfo, beShopDs } = useGlobalModel(({ user, beShopDs }) => [user, beShopDs])
    const { getTreeNodeNameValue } = useDictModel();
    const initFormVal = {
        id: "",
        code: "",
        shopName
    };
    const [tabActive, setTabActive] = useState<IDtpTabEnum>(IDtpTabEnum.BASE_DETAIL) //tabs 选中

    //编辑缓存
    const [editFormVal, setEditFormVal] = useState<IDtpDetail>(initFormVal);
    const [editList, setEditList] = useState<IDtpMaterialDetail[]>([]);
    const [auditFields, setAuditFields] = useState<IAuditPdf>({});
    //新增缓存
    const [addFormVal, setAddFormVal] = useState<IDtpDetail>(initFormVal);
    const [addList, setAddList] = useState<IDtpMaterialDetail[]>([]);

    //添加商品弹框
    const [materialDialog, setMaterialDialog] = useState<boolean>(false);

    const [showDoc, setShowDoc] = useState<IPdfType>({
        customs_clearance: false,
        invoice: false,
        encasement: false,
    })
    const [currency, setCurrency] = useState<string>("")  //币种符号
    //重置页面缓存
    const resetPageCache = (mode: string) => {
        if (mode === "edit") {
            setEditFormVal(initFormVal);
            setEditList([]);
            setAuditFields({})
            setShowDoc({
                customs_clearance: false,
                invoice: false,
                encasement: false,
            })
        }
        else if (mode === "add") {
            setAddFormVal(initFormVal);
            setAddList([]);
        }
        setTabActive(IDtpTabEnum.BASE_DETAIL);
    }

    //主单修改
    const updateFormVal = (mode: string, val?: object | null) => {
        const setFormVal = mode === "edit" ? setEditFormVal : setAddFormVal;
        setFormVal((origin: any) => val ? { ...origin, ...val } : initFormVal);
    }

    //商品子表修改
    const updateList = (mode: string, val: IDtpMaterialDetail[]) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        setList([...val]);
    }

    //商品子表添加
    const insertMaterial = (mode: string, arr: IMaterialDetail[]) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        setList(origin => {
            let newArr: IDtpMaterialDetail[] = [...origin];
            arr.forEach(material => {
                //选中的是否存在列表
                let isExist = origin.find(item => item.materialCode == material.code);
                if (!isExist) {
                    // newArr.push({
                    // "key": material.id,  //自己用
                    // "materialId": material.id, // "物料id",
                    // "materialCode": material.code, // "物料编号",
                    // "replaceCode": material.replaceCode, // "替换号",
                    // "materialName": material.name, // "物料名称",
                    // "materialEname": material.nameEn, // "物料名称",
                    // "typeCode": material.typeCode, // "物料类型",
                    // "typeName": material.typeName, // "物料类型名称",
                    // "num": material.num, // "询价数量",
                    // "model": material.model, // "规格",
                    // "note": "", // "备注"
                    // })
                }
            });
            return newArr;
        });
        setMaterialDialog(false);
    }

    //商品子表删除
    const removeMaterial = (mode: string, selectedRowKeys: string[]) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        setList(origin => origin.filter(item => selectedRowKeys.indexOf(item.key) < 0));
    }

    //获取一条数据
    const getDtpDetailOne = async (id: string) => {
        let { retData } = await enquiryService.one(id);
        let { details, createBills, ...formVal } = retData;
        if (retData) {
            setCurrency(getTreeNodeNameValue(details?.[0].currency))

            setEditList(details?.map(item => ({ ...item, key: item.id ?? "" })) ?? []);
            createBills = createBills ?? ""
            setShowDoc({
                customs_clearance: createBills.indexOf("customs_clearance") > -1,
                invoice: createBills.indexOf("invoice") > -1,
                encasement: createBills.indexOf("encasement") > -1,
            });
           
            setEditFormVal({
                ...formVal,
                freight:formVal.freight?formatNum(formVal.freight):formVal.freight,
                premium:formVal.premium?formatNum(formVal.premium):formVal.premium,
                roughWeight:formVal.roughWeight?formatNum(formVal.roughWeight):formVal.roughWeight,
                suttle:formVal.suttle?formatNum(formVal.suttle):formVal.suttle,
                incidentals:formVal.incidentals?formatNum(formVal.incidentals):formVal.incidentals,
                // volume:formVal.volume?formatNum4(formVal.volume):formVal.volume,
                createBills,
                departureTime: formVal.departureTime ? moment(retData.departureTime) : null,
                declareTime: formVal.declareTime ? moment(retData.declareTime) : null,
                invoiceTime: formVal.invoiceTime ? moment(retData.invoiceTime) : null,
                //createTime: momentFormat(formVal.createTime as string, "YYYY-MM-DD HH:mm:ss"),
                createTime: moment(formVal.createTime , "YYYY-MM-DD HH:mm:ss"),
                //updateTime: momentFormat(formVal.updateTime, "YYYY-MM-DD HH:mm:ss")
                updateTime: moment(formVal.updateTime, "YYYY-MM-DD HH:mm:ss")
            });
        }
        return retData;
    };

    // //获取币种符号
    // const getcurrencySymbol = (mode: string) => {
    //     let currencyCode: string | undefined = mode === "edit" ? editFormVal.currencyCode : addFormVal.currencyCode;
    //     if (!currencyCode) return ""
    //     return getTreeNodeValue(currencyCode);
    // }

    function isEmptyStr(s: string | null | undefined) {
        if (s == undefined || s == null || s == ''||s == ' ') {
            return true
        }
        return false
    }

    //新增 | 编辑
    const insertOrUpdateDtp = useLockFn(async (mode: string, formVal: IDtpDetail) => {
        const materialList = mode === "edit" ? editList : addList;
         const formV = mode === "edit" ? editFormVal : addFormVal;
        let data = {
            ... formV,
            ...formVal,
            // num: +formatInt(formVal.num),
            // roughWeight: +formatNum(formVal.roughWeight),
            // suttle: +formatNum(formVal.suttle),
            // volume: +formatNum(formVal.volume),
            // freight: +formatNum(formVal.freight),
            // premium: +formatNum(formVal.premium),
            // incidentals: +formatNum(formVal.incidentals),
            supplierName: beShopDs.find(item => item.value === formVal.supplierCode)?.label ?? formVal.supplierName,
            departureTime: formV.departureTime instanceof Object ? formV.departureTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            //declareTime: formV?.declareTime ? moment(formV.declareTime).format('YYYY-MM-DDTHH:mm:ss') : undefined,
            declareTime:formV.declareTime instanceof Object ? formV.declareTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            invoiceTime: formV.invoiceTime instanceof Object ? formV.invoiceTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            //createTime: formVal.createTime instanceof Object ? formVal.createTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            //updateTime: formVal.updateTime instanceof Object ? formVal.updateTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            createTime:formVal?.createTime ? moment(formVal.createTime).format('YYYY-MM-DDTHH:mm:ss') : undefined,
            updateTime:formVal?.updateTime ? moment(formVal.updateTime).format('YYYY-MM-DDTHH:mm:ss') : undefined,
            drawbackTime: formVal?.drawbackTime ? moment(formVal.drawbackTime).format('YYYY-MM-DDTHH:mm:ss') : undefined,
            shopCode, shopName,
            // auditFlag: JSON.stringify(auditFields), //临时
            details: materialList
        };
        //新增
       
        if (mode === "edit") {
            if(isEmptyStr(data.deliveryNumber)){
                message.warning('提运单号是必填项 请输入提运单号')
                return false
            }
           
            delete editFormVal.updateUser
            delete data.updateUser
            let { retData } = await enquiryService.update({ ...editFormVal, ...data,id: editFormVal.id, code: editFormVal.code ?? "" });
            getDtpDetailOne(editFormVal.code)
            message.success("保存成功")
            return retData;
        } else {
            if(isEmptyStr(data.deliveryNumber)){
                message.warning('提运单号是必填项 请输入提运单号')
                return false
            }
            let { retData } = await enquiryService.insert(data);
            message.success("新增成功,自动转换至编辑详情页")
            return retData;
        }
    })

    //导出
    const exportDtp = async () => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            let result = await enquiryService.detailExport(editFormVal.code, shopCode);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }

    //报价单明细下载模板
    const downloadTpl = async () => {
        let result = await enquiryService.downloadTpl();
        convertRes2Blob(result);
    }

    //提交审核
    const submitCustoms = useLockFn(async () => {
        // let formRes = await insertOrUpdateCustoms("edit", editFormVal, false);
        let { retData } = await enquiryService.submitCustoms(editFormVal.code);
        getDtpDetailOne(editFormVal.code)
        message.success("提交审核成功");
        return retData;
    })

    //总监审核
    const examineManager = useLockFn(async (status: "0" | "1", advise?: string) => {

        let data = {
            status, advise,
            code: editFormVal.code,
            auditFlag: JSON.stringify(auditFields)
        }
        let { retData } = await enquiryService.examineManager(data);
        getDtpDetailOne(editFormVal.code)
        message.success("已提交总监审核");
        return retData;
    })

    //经理审核
    const examineReckoner = useLockFn(async (status: "0" | "1", advise?: string) => {
        let data = {
            status, advise,
            code: editFormVal.code,
            auditFlag: JSON.stringify(auditFields)
        }
        let { retData } = await enquiryService.examineReckoner(data);
        getDtpDetailOne(editFormVal.code)
        message.success("已提交经理审核");
        return retData;
    })

    //单据生成
    const onCreateBills = useLockFn(async (createBills: string) => {
        let { retData } = await enquiryService.createBills({
            code: editFormVal.code,
            createBills
        });
        getDtpDetailOne(editFormVal.code)
        message.success("单据已生成");
        return retData;
    })

    //转退税单据
    const transferDrawback = useLockFn(async () => {
        let { retData } = await enquiryService.transferDrawback({
            code: editFormVal.code,
            shopCode
        });
        getDtpDetailOne(editFormVal.code)
        message.success("操作成功");
        return retData;
    })

    //单据导出
    const exportOrder = useLockFn(async () => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            const searchParams = {
                shopCode,
                singleCode: editFormVal.code,
                pageSize: -1,
                pageNum: 1,
            };

            let result = await enquiryService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    })
    return {
        /***field***/
        editFormVal,
        editList,
        addFormVal,
        addList,
        tabActive, setTabActive,
        materialDialog, setMaterialDialog,
        showDoc, currency,
        /***method***/
        getDtpDetailOne,
        updateFormVal,
        updateList,
        removeMaterial,
        insertMaterial,
        insertOrUpdateDtp,
        resetPageCache,
        exportDtp,
        downloadTpl,
        setShowDoc,
        auditFields, setAuditFields,
        submitCustoms, examineManager, examineReckoner, onCreateBills,
        exportOrder, transferDrawback
    }
});